import type {Result, UseCase} from 'framework';
import type {AssistantError} from '../../domain/errors';
import type {AssistantRepository, DeleteAttachmentInput} from '../ports/assistant.repository';

export class DeleteAttachment implements UseCase<[DeleteAttachmentInput], void> {
  constructor(private readonly repository: AssistantRepository) {}

  execute(input: DeleteAttachmentInput): Promise<Result<void, AssistantError>> {
    return this.repository.deleteAttachment(input);
  }
}
